var Reminder = (function () {
    function Reminder() {
        this.time = { hours: undefined, minutes: undefined };
        this.repeatOnDays = {
            mo: false,
            di: false,
            mi: false,
            do: false,
            fr: false,
            sa: false,
            so: false,
        };
        this.isActive = true;
    }
    return Reminder;
}());
export { Reminder };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/models/Reminder.ts.pre-build-optimizer.js